import API from 'app/gamma/src/api';
import { Dispatch } from 'app/gamma/src/types';
import { MemberResponse } from 'app/gamma/src/types/responses';
import { Action, actionCreator } from '@trello/redux';
import { BOARD_FIELDS_MINIMAL } from './fields';

// Action types
export const LOAD_MEMBER_CARDS_REQUEST = Symbol(
  'loaders/LOAD_MEMBER_CARDS_REQUEST',
);
export const LOAD_MEMBER_CARDS_SUCCESS = Symbol(
  'loaders/LOAD_MEMBER_CARDS_SUCCESS',
);
export const LOAD_MEMBER_CARDS_ERROR = Symbol(
  'loaders/LOAD_MEMBER_CARDS_ERROR',
);

export type LoadMemberCardsSuccessAction = Action<
  typeof LOAD_MEMBER_CARDS_SUCCESS,
  MemberResponse
>;

// Action creators
export const loadMemberCardsRequest = actionCreator(LOAD_MEMBER_CARDS_REQUEST);
export const loadMemberCardsSuccess = actionCreator<LoadMemberCardsSuccessAction>(
  LOAD_MEMBER_CARDS_SUCCESS,
);
export const loadMemberCardsError = actionCreator(LOAD_MEMBER_CARDS_ERROR);

export const loadMemberCards = (idMemberOrUsername: string) => {
  return async (dispatch: Dispatch) => {
    try {
      dispatch(loadMemberCardsRequest(idMemberOrUsername));

      const member = await API.client.rest.get<MemberResponse>(
        `members/${idMemberOrUsername}`,
        {
          query: {
            boards: 'open,starred',
            board_fields: BOARD_FIELDS_MINIMAL,
            board_memberships: 'me',
            cards: 'visible',
          },
        },
      );

      dispatch(loadMemberCardsSuccess(member));
    } catch (err) {
      dispatch(loadMemberCardsError(err));
    }
  };
};
